import { Header } from "./components/Header";
import { LoaderScreen } from "./sections/LoaderScreen";
import { LetterFromHeart } from "./sections/LetterFromHeart";
import { CounterIntro } from "./sections/CounterIntro";
import { UnlockSection } from "./sections/UnlockSection";
import { SuccessSection } from "./sections/SuccessSection";
import { HeroSection } from "./sections/HeroSection";
import { TimeMeaning } from "./sections/TimeMeaning";
import { MeaningNote } from "./sections/MeaningNote";
import { SurpriseSection } from "./sections/SurpriseSection";
import { VideoSection } from "./sections/VideoSection";
import { ForeverSection } from "./sections/ForeverSection";
import { ClosureSection } from "./sections/ClosureSection";
import { useTheme } from "./hooks/useTheme";
import { useStoryboard } from "./hooks/useStoryboard";

function App() {
  const { theme, toggleTheme, mounted } = useTheme();
  const { currentStep, nextStep, previousStep, restartStory } = useStoryboard();

  if (!mounted) {
    return null;
  }

  const headerHidden = ["LOADER", "SURPRISE"].includes(currentStep);

  return (
    <div className="w-full min-h-screen bg-warmWhite dark:bg-darkBg transition-colors duration-400">
      <Header theme={theme} onToggleTheme={toggleTheme} hidden={headerHidden} />

      {/* Loader Screen */}
      {currentStep === "LOADER" && <LoaderScreen onComplete={nextStep} />}

      {/* Counter Intro */}
      {currentStep === "COUNTER" && (
        <CounterIntro onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Unlock Section */}
      {currentStep === "UNLOCK" && (
        <UnlockSection onSuccess={nextStep} onPrevious={previousStep} />
      )}

      {/* Success Section */}
      {currentStep === "SUCCESS" && (
        <SuccessSection onContinue={nextStep} onPrevious={previousStep} />
      )}

      {/* Hero Section */}
      {currentStep === "HERO" && (
        <HeroSection onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Time Meaning */}
      {currentStep === "TIME" && (
        <TimeMeaning onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Letter From Heart */}
      {currentStep === "LETTER" && (
        <LetterFromHeart onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Meaning Note */}
      {currentStep === "MEANING" && (
        <MeaningNote onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Surprise Section */}
      {currentStep === "SURPRISE" && (
        <SurpriseSection onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Video Section */}
      {currentStep === "VIDEO" && (
        <VideoSection onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Forever Section */}
      {currentStep === "FOREVER" && (
        <ForeverSection onNext={nextStep} onPrevious={previousStep} />
      )}

      {/* Closure Section */}
      {currentStep === "CLOSURE" && <ClosureSection onRestart={restartStory} />}
    </div>
  );
}

export default App;
